import "./HomeSummary.css";
const HomeSummary = () => {
  return (
    <>
      <div className="summary">
        <section className="xl-gutter img-xl sm-padding sm-brr">
          <h3 className="para-lg xs-gutter">Welcome To Shoemakers' Lane</h3>
          <p className="para-sm-xs xs-gutter">
            The Shoemaker’s Lane is your one-stop shop for all your footwear
            needs. We give you the best of the best choices one can want. Grab
            our shoes for an economical and satisfying experience. We are a
            sustainable, eco-friendly brand. Toss on a pair of our shoes and
            show your support for a greener planet!
          </p>
        </section>
      </div>
    </>
  );
};

export default HomeSummary;
